import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class StompInAnimation extends Animation {

    private readonly type: "left" | "right";

    constructor(type: "left" | "right") {
        super();
        this.type = type;
    }

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const startX = this.type === "right" ? this.getRightmostPosition(item, context) : this.getLeftmostPosition(item, context);
        const endX = item.x;
        const top = item.y - 100;
        const bottom = item.y;
        const n = 4;
        let i = 0;
        const onUpdate = () => this.updatePaperCut(item);
        const step = (delay?: number) => {
            const duration = 0.4;
            item.moveYTo(top, duration * 0.7, Ease.quadOut, {
                delay,
                onUpdate,
                onComplete: () => {
                    item.moveYTo(bottom, duration * 0.3, Ease.quadIn, {
                        onUpdate,
                    });
                },
            });
            item.x = endX + (startX - endX) * (n - i) / n;
            i++;
            item.moveXTo(endX + (startX - endX) * (n - i) / n, duration, Ease.sineOut, {
                delay,
                onUpdate,
                onComplete: () => {
                    if (i < n) {
                        step(0.4);
                    } else {
                        this.onComplete();
                        cb();
                    }
                },
            });
        };
        step(this.delay);
        if (this.delay) {
            this.updatePaperCut(item);
        }
    }
}
